module.exports = __webpack_public_path__ + "static/media/whatsapp.13e647d4.svg";